const StensileQuotationFormData={
    x:"",
    y:"",
    conformButton : false
}
export default StensileQuotationFormData;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/StencilQuotationForm/StencilCustomizedSize/StensileQuotationFormData.js